import clsx from "clsx";

import styles from "./SliderButton.module.scss";

interface SliderButtonProps {
  isCursorDisabled: boolean;
  isRight: boolean;
  onClick: () => void;
  classNames?: string;
}

export function SliderButton({
  isCursorDisabled,
  isRight,
  onClick,
  classNames,
}: SliderButtonProps): React.ReactNode {
  const title = isRight ? "次のスライド" : "前のスライド";
  const svg = isRight
    ? "M223.18 628.49a35 35 0 0 1-24.75-59.75L388.17 379 198.43 189.26a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L247.93 618.24a34.89 34.89 0 0 1-24.75 10.25z"
    : "M437.67 129.51a35 35 0 0 1 24.75 59.75L272.67 379l189.75 189.74a35 35 0 1 1-49.5 49.5L198.43 403.75a35 35 0 0 1 0-49.5l214.49-214.49a34.89 34.89 0 0 1 24.75-10.25z";

  return (
    <button
      className={clsx(styles.button, classNames, "btn")}
      type="button"
      disabled={isCursorDisabled}
      onClick={() => onClick()}
    >
      <svg
        aria-hidden="true"
        focusable="false"
        role="presentation"
        className={styles.icon}
        viewBox="0 0 284.49 498.98"
      >
        <path d={svg} transform="translate(-188.18 -129.51)" />
      </svg>
      <span className={styles.iconText}>{title}</span>
    </button>
  );
}
